import { render } from "./DriversCard.vue?vue&type=template&id=6b2e3775&scoped=true"
import script from "./DriversCard.vue?vue&type=script&lang=js"
export * from "./DriversCard.vue?vue&type=script&lang=js"

import "./DriversCard.vue?vue&type=style&index=0&id=6b2e3775&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2e3775"]])

export default __exports__